import React from 'react'
import PropTypes from 'prop-types'
import { Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, Text, useBreakpointValue, Button } from '@chakra-ui/react'
import { FormattedMessage } from 'react-intl'
import { getCountryName } from '../../utils/utils'

const CountrySelectorConfirmationDrawer = ({
    isOpen,
    onClose,
    fromCountry,
    toCountry,
    onConfirmation
}) => {
    const drawerPlacement = useBreakpointValue({ base: 'bottom', md: 'right' });

    const handleYes = () => {
        onConfirmation('yes')
        onClose()
    }

    const handleNo = () => {
        onConfirmation('no')
        onClose()
    }

    return (
        <Drawer
            isOpen={isOpen}
            onClose={handleNo}
            size="sm"
            placement={drawerPlacement}
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton top="22px" />
                <DrawerHeader
                    color="black"
                    fontSize="md"
                    lineHeight="20px"
                    fontWeight="700"
                    textTransform="uppercase"
                    boxShadow="none"
                    paddingTop={{ base: '20px', md: '26px' }}
                    paddingInline={{ base: '16px', md: '24px' }}
                    paddingBottom={{ base: 0, md: '10px' }}
                >
                    <FormattedMessage
                        id="country_selector_drawer.title"
                        defaultMessage="Confirm Shipping Country"
                    />
                </DrawerHeader>
                <DrawerBody paddingBottom="24px !important">
                    <Text
                        color="black"
                        fontSize="sm"
                        lineHeight="18px"
                        marginBottom="32px"
                    >
                        <FormattedMessage
                            id="country_selector_drawer.message"
                            defaultMessage="You are currently shopping on {country} website. When changing countries your shopping bag will be emptied. Are you sure you want to proceed?"
                            values={{
                                country: getCountryName(fromCountry),
                            }}
                        />
                    </Text>
                    <Button
                        data-testid="country-confirm-yes-button"
                        onClick={handleYes}
                        backgroundColor="black"
                        textAlign="center"
                        fontSize="md"
                        width="100%"
                        marginBottom="8px"
                    >
                        <FormattedMessage
                            id="country_selector_drawer_cta.continue_to"
                            defaultMessage="Yes, continue to {country}"
                            values={{
                                country: getCountryName(toCountry),
                            }}
                        />
                    </Button>
                    <Button
                        data-testid="country-confirm-no-button"
                        onClick={handleNo}
                        backgroundColor="white"
                        color="black"
                        textAlign="center"
                        fontSize="md"
                        variant="outline"
                        width="100%"
                    >
                        <FormattedMessage
                            id="country_selector_drawer_cta.return_to"
                            defaultMessage="No, return to {country}"
                            values={{
                                country: getCountryName(fromCountry),
                            }}
                        />
                    </Button>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}

CountrySelectorConfirmationDrawer.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    fromCountry: PropTypes.string,
    toCountry: PropTypes.string,
    onConfirmation: PropTypes.func,
}

export default CountrySelectorConfirmationDrawer
